import type { StokKaynaklari } from './ekranKaynaklari';

/** Stok Analizi'nin konu sekmeleri (kullanici, 2026-11-01). */
export type StokSekme = 'kayip' | 'sermaye' | 'akis';

export const VARSAYILAN_STOK_SEKMESI: StokSekme = 'kayip';

export const STOK_SEKMELERI: ReadonlyArray<{ anahtar: StokSekme; ad: string }> = [
  { anahtar: 'kayip', ad: 'Fire ve kayıp' },
  { anahtar: 'sermaye', ad: 'Sıkışan sermaye' },
  { anahtar: 'akis', ad: 'Stok akışı' },
];

export function stokSekmesiMi(x: string | null): x is StokSekme {
  return STOK_SEKMELERI.some((s) => s.anahtar === x);
}

/** Firmanin kaynaklarinda karsiligi olmayan sekme cizilmez; kosullar bloklarin kendi "kaynak yok" kuraliyla ayni. */
export function stokSekmesiVarMi(sekme: StokSekme, k: StokKaynaklari): boolean {
  switch (sekme) {
    case 'kayip':
      return !!(k.kayipOzet || k.kayipSeyir || k.kayipCiro || k.kayipKategori || k.subeGuvenilirlik || k.kayipUrun);
    case 'sermaye':
      return !!(k.oluStokTur || k.abc);
    case 'akis':
      return !!(k.devirHizi || k.sellThrough || k.stokGun || k.subeFark);
  }
}
